import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ApiService } from '../services/api.service';
import { StorageService } from '../services/storage.service';

function jwtHasUserId(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return !!payload?.id;
  } catch {
    return false;
  }
}

function isAuthorizedOk(res: unknown): boolean {
  if (res === true) return true;
  if (res && typeof res === 'object') {
    const r = res as { result?: boolean; data?: { id?: number } };
    // Richiede id nel JWT decodificato (sessioni pre-modifica senza id → fuori)
    return r.result === true && !!r.data?.id;
  }
  return false;
}

export const authGuard: CanActivateFn = () => {
  const apiService = inject(ApiService);
  const storageService = inject(StorageService);
  const router = inject(Router);

  const user = storageService.getUser();
  const token = storageService.getToken();
  if (!user?.id || !token || !jwtHasUserId(token)) {
    storageService.clearStorage();
    router.navigate(['/backoffice/login']);
    return false;
  }

  return apiService.isAuthorized().pipe(
    map((res) => {
      if (!isAuthorizedOk(res)) {
        storageService.clearStorage();
        router.navigate(['/backoffice/login']);
        return false;
      }
      return true;
    }),
    catchError(() => {
      storageService.clearStorage();
      router.navigate(['/backoffice/login']);
      return of(false);
    }),
  );
};
